import { REGIONS } from '../../utils/constants'
import { getExcelWorksheet } from './common'
import { allColumns, getColumnLayout } from './commonStatementFunctions'

export const getPeriodFromFile = (worksheet) => worksheet.getCell(`A1`).value

export function checkFileFormat(filename) {
  return new Promise((resolve) => {
    if (filename.slice(-5) === '.xlsx') resolve(true)
    resolve(false)
  })
}

function checkRegions(worksheet, columnsCount) {
  const layout = getColumnLayout(columnsCount)
  for (let i = 0; i < REGIONS.length; i++) {
    const colLetter = allColumns[layout.regionsStart + i]
    const cellValue = worksheet.getCell(`${colLetter}2`).value
    if (!cellValue || !String(cellValue).includes(REGIONS[i].code)) return false
  }
  return true
}
function checkDate(date) {
  if (typeof date !== 'string') return false
  if (date.split(' ').length !== 2) return false
  return true
}
export async function checkData(file, columnsCount) {
  const worksheet = await getExcelWorksheet(file)
  return new Promise(async (resolve) => {
    if (!checkRegions(worksheet, columnsCount)) resolve(false)
    if (!checkDate(getPeriodFromFile(worksheet))) resolve(false)
    resolve(true)
  })
}

function getCoopGroupsFromFile(worksheet, length) {
  const names = []
  for (let i = 3; i < length + 3; i++) {
    names.push(worksheet.getCell(`A${i}`).value)
  }
  return names
}
export function checkCoopGroups(file, lastAgreement) {
  return new Promise(async (resolve) => {
    const worksheet = await getExcelWorksheet(file)

    const coopGroupsLength = lastAgreement.coopGroups.length
    if (worksheet.getCell(`A${coopGroupsLength + 3}`).value !== 'Total') resolve(false)

    const coopGroupsName = lastAgreement.coopGroups.map((group) => group.name)
    const coopGroupsNameFromFile = getCoopGroupsFromFile(worksheet, coopGroupsLength)

    if (coopGroupsLength !== coopGroupsNameFromFile.length) resolve(false)
    if (!coopGroupsName.every((name) => coopGroupsNameFromFile.includes(name))) resolve(false)

    resolve(true)
  })
}

function isEmptyCellValue(cellValue) {
  if (cellValue === null || cellValue === undefined) return true
  if (typeof cellValue === 'object' && cellValue.result !== undefined) {
    const result = cellValue.result
    return result === null || result === undefined || String(result).replaceAll(' ', '') === ''
  }
  return String(cellValue).replaceAll(' ', '') === ''
}

function isNumericCellValue(cellValue) {
  const rawValue = typeof cellValue === 'object' && cellValue.result !== undefined ? cellValue.result : cellValue
  return rawValue !== '' && !isNaN(Number(rawValue))
}

export function checkAmount(file, coopGroups, columnsCount) {
  return new Promise(async (resolve) => {
    const worksheet = await getExcelWorksheet(file)
    const layout = getColumnLayout(columnsCount)

    const cellsToCheck = []
    coopGroups.forEach((_group, index) => {
      for (let i = layout.regionsStart; i <= layout.regionsEnd; i++) {
        cellsToCheck.push(`${allColumns[i]}${index + 3}`)
      }
    })

    for (const cell of cellsToCheck) {
      const cellValue = worksheet.getCell(cell).value
      if (isEmptyCellValue(cellValue)) continue
      if (!isNumericCellValue(cellValue)) resolve(false)
    }

    resolve(true)
  })
}
